const columns = [
  {
    name: 'State',
    selector: (row) => row.name,
  },
  {
    name: 'Country',
    selector: (row) => row.country,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
